import { queryKeys } from '@/lib/query-keys';
import { organizationClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';
import type {
  CreateOrganizationBody,
} from '@octave/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useCreateOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (organization: CreateOrganizationBody) => {
      const res = await organizationClient.createOrganization({
        body: organization,
      });
      if (res.status !== 201) throw new Error('Failed to create organization');
      return res.body;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.notOnboarded(),
      });
    },
  });
};

export const useArchiveOrganization = () => {
  const queryClient = useQueryClient();
  const log = createLogger('useArchiveOrganization');

  return useMutation({
    mutationFn: async ({
      organizationId,
      confirmationName,
    }: {
      organizationId: string;
      confirmationName: string;
    }) => {
      const res = await organizationClient.archiveOrganization({
        params: { organizationId },
        body: { confirmationName },
      });
      if (res.status !== 200) throw new Error('Failed to archive');
      return res.body;
    },
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.organizations.all() });
      queryClient.invalidateQueries({ queryKey: queryKeys.organizations.switcher() });
      toast.success(`Organisation ${result.name} supprimée`);
    },
    onError: (error) => {
      toast.error('La suppression a échoué');
      log.error('Failed to archive organization', { error });
    },
  });
};
